import React, { useState } from 'react';
import { Modal, Select, Button } from 'antd';
const { Option } = Select;

interface DuplicationReasonPopupProps {
    isOpen: boolean;
    partName: string;
    type: 'request_requote' | 'request_change_files';
    onChangeReason?: (reason: string) => void;
    onConfirm: (reason: string) => void;
    onCancel?: () => void;
}

const DuplicationReasonPopup: React.FC<DuplicationReasonPopupProps> = ({
    isOpen,
    partName,
    type,
    onChangeReason,
    onConfirm,
    onCancel,
}) => {
    const [selectedReason, setSelectedReason] = useState('');

    const handleConfirm = () => {
        onConfirm(selectedReason);
    };

    const handleChange = (value: string) => {
        setSelectedReason(value);
        if (onChangeReason) onChangeReason(value);
    };

    const modalTitle = type === 'request_requote' ? 'Request for Requote' : 'Select a reason for the new file';

    const modalMessage =
        type === 'request_requote'
            ? `Please select a reason for the change related to the part ${partName} not being quoted and your request for a new quote.`
            : `It appears that you’re updating a file for ${partName}. Please select a reason for the change.`;

    return (
        <Modal
            title={modalTitle}
            visible={isOpen}
            onOk={handleConfirm}
            onCancel={onCancel}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleConfirm} disabled={!selectedReason}>
                    Confirm
                </Button>,
            ]}
        >
            <p>{modalMessage}</p>
            <Select value={selectedReason} onChange={handleChange} style={{ width: '100%' }}>
                <Option value="">Please select...</Option>
                <Option value="To Correct or Provide Additional Information">
                    To Correct or Provide Additional Information
                </Option>
                <Option value="To Update the Revision">To Update the Revision</Option>
            </Select>
        </Modal>
    );
};

export default DuplicationReasonPopup;
